const STEPS = ["Rodzaj usługi", "Usługa", "Termin i dane"];

export const Stepper = ({ current }) => (
  <ol data-testid="booking-stepper" className="flex items-center gap-3 sm:gap-8">
    {STEPS.map((label, i) => {
      const n = i + 1;
      const active = n === current;
      const done = n < current;
      return (
        <li key={label} data-testid={`stepper-step-${n}`} className="flex items-center gap-2">
          <span className={`w-7 h-7 rounded-full grid place-items-center text-xs font-bold border transition-colors
            ${active || done ? "bg-primary text-primary-foreground border-primary" : "border-white/30 text-white/60"}`}>{n}</span>
          <span className={`text-xs sm:text-sm ${active ? "text-primary font-semibold" : "text-white/55"} ${active ? "" : "hidden md:inline"}`}>{label}</span>
        </li>
      );
    })}
  </ol>
);
